import TypographyContainer from '../../Component/Ui-Kits/Typography/Typography'

const Typography = () => {
  return (
    <div className='page-body'>
      <TypographyContainer />
    </div>
  )
}

export default Typography